window.__odrConfig = window.__odrConfig || [];
window.__odrLoaderStarted = window.__odrLoaderStarted || false;
window.__odrGaStarted = window.__odrGaStarted || false;
window.__odrGaLoaded = window.__odrGaLoaded || false;
window.__odrErrorsCapturing = window.__odrErrorsCapturing || false;
window.__odrSearchVars = window.__odrSearchVars || { value: '' };
window.__odr = window.__odr || {
    requestPrefetch: [],
};
window.OA = window.OA || [];
window.__odrDebugEmail = JSON.parse(window.localStorage.getItem('__odr_debugEmail:0'));
window.__odrDebugIvrServer = JSON.parse(window.localStorage.getItem('__odr_debugIvrServer:0'));
window.AppointWidget = {
    openChat: () => {
        window.__odrChatVars.opened = true;
    },
    closeChat: () => {
        window.__odrChatVars.opened = false;
    },
};
